<template>
  <div class="ssoLogin">
    <iframe
      ref="iframeBg"
      class="iframe_background"
      :src="iframeBgPath"
    />
    <div class="ssoIframe">
      <iframe
        ref="iframe"
        class="iframe_login"
        :src="iframePath"
        :style="iframeStyle"
      />
    </div>
  </div>
</template>

<script>
import { computed, reactive, ref, onMounted } from '@vue/composition-api';
import { mapValues } from 'lodash-es';
import { initIframeMessageForward } from '@/sso_common/iframeReq';
export default {
  components: {},
  setup() {
    if (location.protocol !== 'https:') {
      location.replace(`https:${location.href.substring(location.protocol.length)}`);
    }
    const iframeBgPath = ref(window.WUJI_SSO_BG_IFRAME);
    const iframePath = computed(() => {
      const newLoginConfig = window.WUJI_SSO_NEW_LOGIN;
      if (newLoginConfig) {
        const { host } = newLoginConfig;
        return `https://${host}/sso/choose_port?via=${host}`;
      }
      return `/sso/choose_port?via=${document.domain}`;
    });
    const iframePos = reactive({
      top: null, left: null,
      height: null, width: null,
    });
    const hideIframe = ref(false);
    const iframeStyle = computed(() => {
      let style = { visibility: 'hidden', opacity: 0, transform: 'scale(0)' };
      if (hideIframe.value) return style;
      if (iframePos.top >= 0 && iframePos.left >= 0) {
        style = mapValues(iframePos, val => `${val}px`);
      }
      return style;
    });
    window.addEventListener('message', (ev) => {
      try {
        const pos = JSON.parse(ev.data);
        iframePos.top = pos.top;
        iframePos.left = pos.left;
        iframePos.width = pos.width;
        iframePos.height = pos.height;
      } catch (e) {
      }
    });
    window.addEventListener('message', async (msgEvt) => {
      const { type, hidden } = msgEvt.data;
      if (type === 'wuji_hide_iframe') {
        hideIframe.value = !!hidden;
      }
    });
    const iframe = ref(null);
    const iframeBg = ref(null);
    onMounted(() => {
      initIframeMessageForward(iframe.value, 'iframe_login');
      initIframeMessageForward(iframeBg.value, 'iframe_background');
    });

    return { iframe, iframeBg, iframePath, iframeBgPath, iframeStyle };
  },
};
</script>

<style lang="scss" scoped>

.iframe_login{
  border:none;
  position:absolute;
  z-index:1;
}

.iframe_background{
  border:none;
  position: absolute;
  height: 100vh;
  width: 100vw;
}


.ssoLogin {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}


@media (min-width: 769px) {
  .ssoIframe {
    height: 503px;
    width: 368px;
    >iframe{
      width: 300px;
      height: 318px;
    }
  }
}

@media (max-width: 768px) {
  .ssoIframe {
    height: 350px;
    width: 280px;
    >iframe{
      width: 240px;
      height: 218px;
    }
  }
}
</style>
